import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { merchant } from 'src/app/core/models/merchant.models';
import { MerchantService } from 'src/app/core/services/merchant/merchant.service';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {

  public maskedMerchants: merchant | any;
  public totalCount = 0;
  public prevLink = "https://ewns.in/customers/1";
  public nextLink = "https://ewns.in/customers/1";
  constructor(private route: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta,
    private merchantService: MerchantService ) { }

  async ngOnInit(): Promise<void> {
    const routeParams = this.route.snapshot.paramMap;
    const index = Number(routeParams.get('id'));

    let skip = (index-1)*12;
    let merchantInfo = await this.merchantService.getMerchants(skip, 12);
    this.maskedMerchants = merchantInfo.merchants;
    this.totalCount = merchantInfo.total;

    
    if(this.totalCount <= (index*12))
    {
      this.nextLink = "#";
      this.prevLink = "https://ewns.in/customers/" + (index-1);
    }
    else{
      this.nextLink = "https://ewns.in/customers/" + (index+1);
      if(index != 1)
      {
        this.prevLink = "https://ewns.in/customers/" + (index-1);
      }
      
    }

    this.setSEOData();
  }

  setSEOData(): void {
   

    let aboutDescription = `Customers of  EWNS, Custom Ecommerce platform to meet all your digital needs, Enable social commerce and Ecommerce in matter of minutes, Create and manage website from anywhere on any device, Enable digital commerce for your business`;

    this.titleService.setTitle(aboutDescription);

    this.metaService.addTag({name: 'name', content: aboutDescription});
    this.metaService.addTag({name: 'description', content: aboutDescription});
    this.metaService.addTag({name: 'image', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})
    this.metaService.addTag({name: 'logo', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})
    this.metaService.addTag({name: 'keywords', content: aboutDescription})


    this.metaService.addTag({name: 'twitter:card', content: 'product'});
    this.metaService.addTag({name: 'twitter:title', content: aboutDescription});
    this.metaService.addTag({name: 'twitter:description', content: aboutDescription});
    this.metaService.addTag({name: 'twitter:image', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})


    //OG GRAPH DATA
    this.metaService.addTag({name: 'og:type', content: 'article'});
    this.metaService.addTag({name: 'og:site_name', content: 'EWNS'});
    this.metaService.addTag({name: 'og:url', content: "https://ewns.in/customers/1"});
    this.metaService.addTag({name: 'og:description', content: aboutDescription});
    this.metaService.addTag({name: 'og:image', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})
  }

}
